module.exports = __webpack_public_path__ + "img/register_pc_01.c777b292.png";